import { sendPack_SB } from '@/api/index'

export function UpadeAccsf_SB (data) {
  return sendPack_SB.request({
    method: 'post',
    url: '/UpadeAccsf_SB',
    data
  })
}

export function ChauffeurInfo_SB (data, params) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return sendPack_SB.request({
    method: 'post',
    url: '/ChauffeurInfo_SB' + extendUrl,
    data
  })
}

export function SendOrders_Modify_SB (data) {
  return sendPack_SB.request({
    method: 'post',
    url: '/SendOrders_Modify_SB',
    data
  })
}

export function CancelSendOrders_SB (data) {
  return sendPack_SB.request({
    method: 'post',
    url: '/CancelSendOrders_SB',
    data
  })
}

export function SaveSendOrders_Modify_SB (data) {
  return sendPack_SB.request({
    method: 'post',
    url: '/SaveSendOrders_Modify_SB',
    data
  })
}

export function fill (data) {
  return sendPack_SB.request({
    method: 'post',
    url: '/fill',
    data
  })
}

export function Query_XML (data, params) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return sendPack_SB.request({
    method: 'post',
    url: '/Query_XML' + extendUrl,
    data
  })
}

export function save (data) {
  return sendPack_SB.request({
    method: 'post',
    url: '/save',
    data,
    iSFromData: true
  })
}

export function ExcelHeavyData (data) {
  return sendPack_SB.request({
    method: 'post',
    url: '/ExcelHeavyData',
    data
  })
}

export function Getsfprice (data) {
  return sendPack_SB.request({
    method: 'post',
    url: '/Getsfprice',
    data,
    iSFromData: true
  })
}

export function SavesfPriceData (data) {
  return sendPack_SB.request({
    method: 'post',
    url: '/SavesfPriceData',
    data
  })
}

export function ResetPwdChauffeurInfo_SB (data) {
  return sendPack_SB.request({
    method: 'post',
    url: '/ResetPwdChauffeurInfo_SB',
    data
  })
}

export function ImportSbOrdersDetails (data) {
  return sendPack_SB.request({
    method: 'post',
    url: '/ImportSbOrdersDetails',
    data,
    iSFromData: true
  })
}

export function ImportData (data) {
  return sendPack_SB.request({
    method: 'post',
    url: '/ImportData',
    data,
    iSFromData: true
  })
}
